import React from "react";
import {
    Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';
import moment from 'moment';
export default class ComponentToPrint extends React.Component {

    render() {
        const cashCountList = this.props.cashCountList;
        const coinTotal = this.props.coinTotal;
        const remainingValueTotal = this.props.remainingValueTotal;
        const selectedSearchValues = this.props.selectedSearchValues;
        const searchDate = this.props.searchDate;
        const prevTotalAmount = this.props.prevTotalAmount;
        const coinNames = this.props.coinNames;
        const columnTitles = this.props.columnTitles;
        const mergedData = this.props.mergedData;
        const selectedDate = this.props.selectedDate;

        let monthNames = ["JAN", "FEB", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUG", "SEPT", "OCT", "NOV", "DEC"];
        var month = selectedDate.getMonth() - 1;
        let monthName = monthNames[month + 1];

        return (
            <div>
                <div style={{ width: '1093px', height: '1059px', padding: '20px', margin: 'auto' }}>
                    <br />
                    <h2><center><u>Cash Denomination Report</u></center></h2>
                    <div>&nbsp;</div>
                    <h3><center>Group: {selectedSearchValues.groupName}</center></h3>
                    <h3><center>Factory: {selectedSearchValues.factoryName}</center></h3>
                    <h3><center>Route: {selectedSearchValues.routeName == undefined ? "All Routes" : selectedSearchValues.routeName}</center></h3>
                    <h3><center>({selectedDate.getFullYear()} - {(monthName === '' ? moment(new Date()).format('MMM') : monthName)})</center></h3>
                    <div>&nbsp;</div>
                    <div>
                        <Box minWidth={1050}>
                            <TableContainer>
                                <Table aria-label="caption table" size='small'>
                                    <TableHead>
                                        <TableRow>
                                            {columnTitles.map((title, index) => (
                                                <TableCell
                                                    size="small"
                                                    key={title}
                                                    align={index === 0 ? "left" : index === columnTitles.length - 1 ? "right" : "center"}
                                                    style={{ border: '1px solid #ccc', fontWeight: 'bold' }}
                                                >
                                                    {index !== 0 && index !== columnTitles.length - 1 ? `Rs. ${title}` : title}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {mergedData.map((data, index) => (
                                            <TableRow key={index}>
                                                <TableCell size="small" align={'left'} component="th" scope="row" style={{ border: '1px solid #ccc' }}>
                                                    {data.routeName}
                                                </TableCell>
                                                {data.cashCount.map((coin, index) => (
                                                    <TableCell size="small" key={coinNames[index]} align='center' component="th" scope="row" style={{ border: '1px solid #ccc', textAlign: "right", paddingRight: "20px" }}>
                                                        {coin.coinCount}
                                                    </TableCell>
                                                ))}
                                                <TableCell size="small" align={'right'} component="th" scope="row" style={{ border: '1px solid #ccc', textAlign: "right", paddingRight: "20px" }}>
                                                    {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                    <TableRow>
                                        <TableCell size="small" align={'left'} style={{ border: '1px solid #ccc', fontWeight: 'bold' }}>Total</TableCell>
                                        {coinTotal.map((coin, index) => (
                                            <TableCell size="small" key={coinNames[index]} align='center' component="th" scope="row" style={{ border: '1px solid #ccc', textAlign: "right", paddingRight: "20px" }}>
                                                {coin.coinCount}
                                            </TableCell>
                                        ))}
                                        <TableCell size="small" align={'right'} component="th" scope="row" style={{ border: '1px solid #ccc', textAlign: "right", paddingRight: "20px" }} >
                                            {prevTotalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                    </TableRow>
                                </Table>
                            </TableContainer>
                        </Box>
                    </div>
                </div>
            </div>
        );
    }
}
